import { apiCall } from "@/api/apiBase";

export interface LoggedInUserDetails {
    id: string;
    email: string;
    isSuper: boolean;
    firmIds: string[];
}

export function getLoggedInUserDetails(): Promise<LoggedInUserDetails> {
    return apiCall<LoggedInUserDetails>("/auth/loggedInUserDetails", "GET");
}
